const AdvertisementComponent = () =>
  import("@/views/advertisement/Advertisement.vue");
const CreateAdvertisement = () =>
  import("@/views/advertisement/CreateAdvertisement.vue");
const ViewAdvertisement = () =>
  import("@/views/advertisement/ViewAdvertisement.vue");
const EditAdvertisement = () =>
  import("@/views/advertisement/EditAdvertisement.vue");

export default {
  path: "advertisement",
  meta: { label: "Advertisements" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: AdvertisementComponent,
    },
    {
      path: "create",
      name: "Create Ad",
      meta: {
        label: "Create Advertisement",
        requiresAuth: true,
      },
      component: CreateAdvertisement,
    },
    {
      path: "view/:id",
      name: "view-advertisement",
      meta: {
        label: "View Advertisement",
        requiresAuth: true,
      },
      component: ViewAdvertisement,
    },
    {
      path: "edit/:id",
      name: "edit-advertisement",
      meta: {
        label: "Edit Advertisement",
        requiresAuth: true,
      },
      component: EditAdvertisement,
    },
  ],
};
